"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHttpSuccess = void 0;
const basics_1 = require("../Math/basics");
/** returns true and asserts HTTPSucess when code is number and between 200 and 300 inclusive
 * Note that where an unusual 2xx code is used, the type assertition will be incorrect, but still number
*/
const isHttpSuccess = (code) => (0, basics_1.between)(code, 200, 300);
exports.isHttpSuccess = isHttpSuccess;
